import { createContext, useContext, useState } from "react";

const SessionContext = createContext(null);

export const SessionProvider = ({ children }) => {
  const [session, setSession] = useState({
    user: sessionStorage.getItem("user"),
    currentVersion: sessionStorage.getItem("currentVersion"),
    currentBuildNumber: sessionStorage.getItem("currentBuildNumber"),
    sessionId: sessionStorage.getItem("sessionId"),
    sessionDuration: sessionStorage.getItem("sessionDuration"),
    privilegeLevel: sessionStorage.getItem("privilegeLevel"),
    termsAgreed: sessionStorage.getItem("termsAgreed"),
    permissions: sessionStorage.getItem("permissions"),
    licenseTypes: sessionStorage.getItem("licenseTypes"),
    columns: sessionStorage.getItem("columns"),
    bundleType: sessionStorage.getItem("bundleType"),
  });

  const setSessionData = (data) => {
    const newSession = {
      user: data.user,
      currentVersion: data.currentVersion,
      currentBuildNumber: data.currentBuildNumber,
      sessionId: data.sessionId,
      sessionDuration: data.sessionDuration,
      privilegeLevel: data.privilegeLevel,
      termsAgreed: data.termsAgreed,
      permissions: data.permissions,
      licenseTypes: data.licenseTypes,
      columns: JSON.stringify(data.columnPreferences),
      bundleType: data.bundleType ?? "common",
    };

    Object.entries(newSession).forEach(([key, value]) => {
      if (value !== null && value !== undefined) {
        sessionStorage.setItem(key, value);
      }
    });

    setSession(newSession);
  };

  const clearSession = () => {
    sessionStorage.clear();
    setSession({
      user: null,
      currentVersion: null,
      currentBuildNumber: null,
      sessionId: null,
      sessionDuration: null,
      privilegeLevel: null,
      termsAgreed: null,
      permissions: null,
      licenseTypes: null,
      columns: null,
      bundleType: null,
    });
  };

  return (
    <SessionContext.Provider value={{ session, setSessionData, clearSession }}>
      {children}
    </SessionContext.Provider>
  );
};

export const useSession = () => useContext(SessionContext);
